exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bannerBox[data-v-5543eec6] .avatar-uploader {\n  width: 2.604167rem;\n  height: 0.927083rem;\n}\n.bannerBox[data-v-5543eec6] .avatar {\n  width: 2.604167rem;\n  height: 0.927083rem;\n}", ""]);

// exports
